import React from 'react';
import './Courses.css';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import CourseItem from './CourseItem';
import Modal from '../../common/Modal/Modal';
import Form from './FormProbaora';
import Reveal from 'react-reveal/Reveal';


const Courses = ({ info, courses, modal, toggleModalState }) => {
  const courseItems = courses.map((course, index) => (
    <CourseItem key={index} slug={course.slug} title={course.title} description={course.description} image={course.image} />
  ));

  return (
    <div className="courses-wrapper">
      <div className="bubble bubble-1 bubble-xl bubble-color-1"></div>
      <div className="bubble bubble-2 bubble-sm bubble-color-4"></div>
      <div className="bubble bubble-3 bubble-sm bubble-color-3"></div>
      <div className="bubble bubble-4 bubble-sm bubble-color-2"></div>
      <div className="bubble bubble-5 bubble-xxl bubble-color-1"></div>
      <div className="bubble bubble-6 bubble-xxxl bubble-color-5"></div>
      <div className="bubble bubble-7 bubble-sm bubble-color-3"></div>
      <div className="bubble bubble-8 bubble-sm bubble-color-4"></div>
      <div className="bubble bubble-9 bubble-sm bubble-color-3"></div>
      <div className="bubble bubble-10 bubble-sm bubble-color-3"></div>
      <div className="bubble bubble-11 bubble-xl bubble-color-1"></div>
      <div className="bubble bubble-12 bubble-xxl bubble-color-5"></div>
      <Reveal effect="grow-in-bottom">
        <section className="courses container" id="kurzusok">
          <h1 className="section__name text-center">Kurzusok</h1>

          <div className="course-items">
            {courseItems}
          </div>

          <button className="my-btn" onClick={toggleModalState}>Jelentkezés ingyenes próbaórára</button>

          <Modal
            title={'Jelentkezés ingyenes próbaórára'}
            show={modal}
            toggleModalState={toggleModalState}
            minWidth={700}
          >
            <p className="courses__description">{ReactHtmlParser(info.text)}</p>
            <hr/>
            <Form />
          </Modal>

        </section>
      </Reveal>
    </div>
  );
};


Courses.propTypes = {
  info: PropTypes.object.isRequired,
  courses: PropTypes.array.isRequired,
  modal: PropTypes.bool.isRequired,
  toggleModalState: PropTypes.func.isRequired
};

export default Courses;



// WEBPACK FOOTER //
// ./src/components/Home/Courses/Courses.js